import InitialState from './initial-state';
import { caseEditsActions } from '../actions/case-edits';
import { getDetail } from '../actions/cases.action';
import { cmxReducerFactory } from './reducer-utils';
import { launchPageActions } from '@codametrix/ui-common';

const reducer = cmxReducerFactory(InitialState.caseEdits)
  .case(caseEditsActions.updateValue, (state, fieldEdit) => {
    const { fieldKey, newValue } = fieldEdit;
    const { caseRun, caseEdits } = state;

    const initialVal = caseRun ? caseRun[fieldKey as keyof CMxAPI.CaseRun] : '';

    caseEdits[fieldKey] = {
      ...caseEdits[fieldKey],
      options: caseEdits[fieldKey]?.options ?? [],
      initialValue: initialVal,
      newValue,
      valueState: 'edit'
    };

    return state;
  })
  .case(getDetail.async.started, (state, payload) => {
    // Clear edits
    return { ...InitialState.caseEdits };
  })
  .cases([getDetail.async.done], (state, { result }) => {
    return {
      ...state,
      caseRun: result.caseRuns[0]
    };
  })
  .cases([launchPageActions.caseRunAvailable], (state, result) => {
    return {
      ...state,
      caseRun: result
    };
  })
  .cases(
    [launchPageActions.caseRunWithRefreshAvailable],
    (state, activeItemWithRefresh) => {
      /**
       * Currently updating latest patient_class and patient_type from XC
       * In future we could add more props
       */
      let caseRun = state?.caseRun;
      if (!!caseRun) {
        caseRun = {
          ...caseRun,
          patient_class:
            activeItemWithRefresh?.patient_class ?? caseRun?.patient_class,
          patient_type:
            activeItemWithRefresh?.patient_type ?? caseRun?.patient_type
        };
      }
      return {
        ...state,
        caseRun
      };
    }
  )
  .case(
    caseEditsActions.loadAllPatientDetailOptions.async.started,
    (state, result) => {
      return {
        ...state,
        caseEdits: InitialState.caseEdits.caseEdits
      };
    }
  )
  .case(
    caseEditsActions.loadPatientDetailOptions.async.done,
    (state, { params, result }) => {
      const { dictionary } = params;
      const { caseRun, caseEdits } = state;

      const initialValue = caseRun
        ? caseRun[dictionary as keyof CMxAPI.CaseRun]
        : '';

      caseEdits[dictionary] = {
        options: result.standardFields.map(item => item.label),
        initialValue,
        newValue: '',
        valueState: 'edit',
        mappedValues: result.standardFields
      };
      if (dictionary === 'patient_type') {
        caseEdits['patient_class'] = {
          options: result.additionalFields.map(item => item.label),
          initialValue,
          newValue: '',
          valueState: 'edit',
          mappedValues: result.additionalFields
        };
      }
      return {
        ...state
      };
    }
  );

export default reducer;
